"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeTime = exports.toISODateString = exports.formatDateTime = exports.getValidDate = exports.formatDate = void 0;
var asDate = function (date) { return (date instanceof Date ? date : new Date(date)); };
var formatDate = function (date) {
    if (!date) {
        return null;
    }
    return (0, exports.removeTime)(asDate(date)).toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
        day: 'numeric',
    });
};
exports.formatDate = formatDate;
var getValidDate = function (date) {
    if (!date) {
        return date;
    }
    date = asDate(date);
    date.setFullYear(Math.min(date.getFullYear(), 9999));
    return date.toISOString().split('T')[0];
};
exports.getValidDate = getValidDate;
var formatDateTime = function (dateTime) {
    return dateTime ? asDate(dateTime).toLocaleString() : null;
};
exports.formatDateTime = formatDateTime;
var toISODateString = function (date) { return asDate(date).toISOString().split('T')[0]; };
exports.toISODateString = toISODateString;
var removeTime = function (date) { return new Date((0, exports.toISODateString)(date) + 'T12:00:00Z'); };
exports.removeTime = removeTime;
